import { parseCookies, setCookie, destroyCookie } from 'nookies';
import { createContext } from 'react';
import { ChildrenOnly } from '../types/ChildrenOnly';

// 1 Day
const TTL = 60 * 60 * 24;

export enum StorageKey {
  BOOKING_PROCESS = 'BookingProcess',
  SEARCH_MEDIUM = 'search_medium',
  SELECTED_PREFERRED_PROVIDER = 'SelectedPreferredProvider',
  SEM_PRACTICE_ID = 'SemPracticeId',
  CHEM2U_TRACKING = 'Chem2U_Tracking',
  PRIVACY_PREFERENCE_TRACKING = 'PrivacyPreference_Tracking',
}

export interface ContextData {
  getData?: (key: string) => string | undefined;
  saveData?: (key: string, data?: string, ttl?: number) => void;
}

export const CookiesContext = createContext<ContextData>({});

export const CookiesProvider = ({ children }: ChildrenOnly) => {
  const getData = (key: string): string | undefined => {
    const cookies = parseCookies();
    if (cookies === null) return undefined;

    return cookies[key] ?? undefined;
  };

  const saveData = (key: string, value?: string, ttl?: number) => {
    if (value !== undefined) {
      setCookie(null, key, value, {
        maxAge: ttl ?? TTL,
        path: '/',
      });
    } else {
      destroyCookie(null, key, {
        path: '/',
      });
    }
  };

  return (
    <CookiesContext.Provider value={{ getData, saveData }}>{children}</CookiesContext.Provider>
  );
};
